<template>
<div>
    <div class="filter-sidebar" v-if="isDesktop">
        <div class="group-filter">
            <p class="filter-name">対象サービス</p>
            <ul class="list-filter" id="list-service">
                <li v-for="(service, key) in serviceNameList" class="item" :key="key">
                    <label class="custom-input" :for="key">
                        <input type="checkbox" name="service_id[]" :id="key" :value="key" autocomplete="off" @change="searchUnit" v-model="service_selected"> {{ service }}
                        <span class="checkmark"></span>
                    </label>
                </li>
            </ul>
        </div>
        <div class="group-filter">
            <p class="filter-name">対象カテゴリ</p>
            <ul class="list-filter" id="list-category">
                <ul class="list-filter" id="list-service">
                    <li v-for="(category, key) in categoryNameList" class="item">
                        <label class="custom-input">
                            <input type="checkbox" name="category_id[]" v-bind:key="key" v-bind:value="key" autocomplete="off" @change="searchUnit" v-model="category_selected"> {{ category }}
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li class="item">
                        <a href="#" class="show-more" v-on:click="showMoreCategory($event)">
                            <i class="fas fa-chevron-down"></i>さらに見る
                        </a>
                    </li>
                </ul>
            </ul>
        </div>
        <div class="group-filter">
            <p class="filter-name">予算</p>
            <ul class="list-filter" id="list-budget">
                <ul class="list-filter" id="list-service">
                    <li v-for="(budget, key) in budgetNameList" class="item">
                        <label class="custom-input">
                            <input type="checkbox" name="budget[]" v-bind:key="key" v-bind:value="key" autocomplete="off" @change="searchUnit" v-model="budget_selected"> {{ budget }}
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li class="item">
                        <label class="custom-input">
                            <input type="checkbox" name="budget[]" value="0" @change="searchUnit" v-model="budget_selected">指定なし
                            <span class="checkmark"></span>
                        </label>
                    </li>
                </ul>
            </ul>
        </div>
        <div class="group-filter" v-if="displayRecruitmentEnd">
            <p class="filter-name">募集ステータス</p>
            <div class="check-recruitment">
                <label class="custom-input" for="recruitmentEnd">募集終了も表示する
                    <input id="recruitmentEnd" name="recruitmentEnd" type="checkbox" value="1" @change="searchUnit" v-model="recruitment_end">
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="top-nav-filter mb-3">
            <div class="group-filter">
                <p class="filter-name" data-target="list-service" v-on:click="expandSelectList">
                    対象サービス <span class="number-sv">{{ this.service_selected.length }}</span>
                    <i class="fas far fa-question-cus" :class="{ 'fa-chevron-up': isListActive == 'list-service', 'fa-chevron-down': isListActive != 'list-service' }" data-target="list-service"></i>
                </p>
            </div>
            <div class="group-filter" v-on:click="expandSelectList">
                <p class="filter-name" data-target="list-category" >
                    対象カテゴリ <span class="number-sv">{{ this.category_selected.length }}</span>
                    <i class="fas far fa-question-cus" :class="{ 'fa-chevron-up': isListActive == 'list-category', 'fa-chevron-down': isListActive != 'list-category' }" data-target="list-category"></i>
                </p>
            </div>
            <div class="group-filter" v-on:click="expandSelectList">
                <p class="filter-name" data-target="list-budget" >
                    予算 <span class="number-sv">{{ this.budget_selected.length }}</span>
                    <i class="fas far fa-question-cus" :class="{ 'fa-chevron-up': isListActive == 'list-budget', 'fa-chevron-down': isListActive != 'list-budget' }" data-target="list-budget"></i>
                </p>
            </div>
        </div>
        <div class="toggle-filter">
            <ul class="list-filter" id="list-service" :class="{ active: isListActive == 'list-service' }" v-show="isListActive == 'list-service' ? true: false">
                <li v-for="(service, key) in serviceNameList" class="item" :key="key">
                    <label class="custom-input" :for="key">
                        <input type="checkbox" name="service_id[]" :id="key" :value="key" autocomplete="off" @change="searchUnit" v-model="service_selected"> {{ service }}
                        <span class="checkmark"></span>
                    </label>
                </li>
            </ul>
            <ul class="list-filter" id="list-category" :class="{ active: isListActive == 'list-category' }" v-show="isListActive == 'list-category' ? true: false">
                <li v-for="(category, key) in categoryNameList" class="item">
                    <label class="custom-input">
                        <input type="checkbox" name="category_id[]" v-bind:key="key" v-bind:value="key" autocomplete="off" @change="searchUnit" v-model="category_selected"> {{ category }}
                        <span class="checkmark"></span>
                    </label>
                </li>
            </ul>
            <ul class="list-filter" id="list-budget" :class="{ active: isListActive == 'list-budget' }" v-show="isListActive == 'list-budget' ? true: false">
                <li v-for="(budget, key) in budgetNameList" class="item">
                    <label class="custom-input">
                        <input type="checkbox" name="budget[]" v-bind:key="key" v-bind:value="key" autocomplete="off" @change="searchUnit" v-model="budget_selected"> {{ budget }}
                        <span class="checkmark"></span>
                    </label>
                </li>
            </ul>
        </div>
        <div class="group-filter" v-if="displayRecruitmentEnd">
            <div class="check-recruitment">
                <label class="custom-input" for="recruitmentEnd">募集終了も表示する
                    <input id="recruitmentEnd" name="recruitmentEnd" type="checkbox" value="1" @change="searchUnit" v-model="recruitment_end">
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'search-condition-component',
        props: {
            serviceNameList: Object,
            categoryNameList: Object,
            budgetNameList: Object,
            application_period: String,
            recruitmentEnd: Number,
            isDesktop: Boolean,
            serviceSelected: Array,
            categorySelected: Array,
            budgetSelected: Array,
            displayRecruitmentEnd: Boolean,
        },
        data() {
          return {
            mute: false,
            error: "",
            service_selected: [],
            category_selected: [],
            budget_selected: [],
            recruitment_end: 0,
            isListActive: '',
          }
        },
        methods: {
            init: function () {
                this.service_selected = !this.serviceSelected ? [0] : this.serviceSelected;
                this.category_selected = !this.categorySelected ? [0] : this.categorySelected;
                this.budget_selected = !this.budgetSelected ? [0] : this.budgetSelected;
                this.recruitment_end = !this.recruitmentEnd ? 0 : this.recruitmentEnd;
            },
            searchUnit: function(data) {
                const form = document.getElementById('formSortBy');
                setTimeout(function(){
                    form.submit();
                }, 500);
            },
            expandSelectList: function(e) {
                const target = e.target.dataset.target;
                if (this.isListActive == target){
                    this.isListActive = "";
                } else {
                    this.isListActive = target;
                }
            },
            showMoreCategory: function(e) {
                e.preventDefault();
                e.target.style.display = 'none';
                let listItem = document.querySelectorAll('#list-category .item');
                for (let i = 0; i < listItem.length; i++) {
                    if (window.getComputedStyle(listItem[i]).display === 'none') {
                        listItem[i].style.display = 'block'
                    }

                }
            }
        },
        created() {
          this.init();
        },
        watch: {
            mute(val) {
              document.getElementById('mute').className = val ? "on" : "";
            }
        },
    }
</script>